<template>
  <div>
    <NavbarSection />
    <HeaderSection />
    <AboutSection />
    <ServiceSection />
    <ReviewSection />
    <TrainingSection />
    <ContactSection />
    <FooterSection />
  </div>
</template>

<script>
import NavbarSection from '@/components/NavbarSection.vue';
import HeaderSection from '@/components/HeaderSection.vue';
import AboutSection from '@/components/AboutSection.vue';
import ServiceSection from '@/components/ServiceSection.vue';
import ReviewSection from '@/components/ReviewSection.vue';
import TrainingSection from '@/components/TrainingSection.vue';
import ContactSection from '@/components/ContactSection.vue';
import FooterSection from '@/components/FooterSection.vue';

export default {
  name: 'HomeView',
  components: {
    NavbarSection,
    HeaderSection,
    AboutSection,
    ServiceSection,
    TrainingSection,
    ReviewSection,
    ContactSection,
    FooterSection
  }
}
</script>
